<template>
  <div class="brand-base">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "brandBase",
};
</script>
